// DO NOT EDIT -- generated from Go package fs/shared/schema/time

///////////
// Enums //
///////////

export enum IntervalGranularity {
	YearGranularity = "year",
	MonthGranularity = "month",
	WeekGranularity = "week",
	DayGranularity = "day",
	HourGranularity = "hour",
	MinuteGranularity = "minute",
	SecondGranularity = "second",
	MillisecondGranularity = "milli"
}

